import React, { useState } from "react";
import Slider from "react-slick";
import {
	AppBar,
	Box,
	Toolbar,
	Typography,
	Button,
	Card,
	CardMedia,
	useMediaQuery,
	useScrollTrigger,
	Slide,
	Tooltip,
	IconButton,
	MenuItem,
	Menu,
} from "@mui/material";
import { useTheme } from "@emotion/react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import academicImage from "../../assets/images/academic.jpg";
import dissertationImage from "../../assets/images/dissertation.jpg";
import publicationImage from "../../assets/images/publication.jpg";
import assignmentImage from "../../assets/images/assignment.jpg";
import internshipImage from "../../assets/images/internship.jpg";
import trainingImage from "../../assets/images/training.jpg";
import DiscountBanner from "../common/discountBanner";
import Header from "../header/header";
import logo from "../../assets/images/logopng.png";
import MenuIcon from "@mui/icons-material/Menu";

import AppsIcon from "@mui/icons-material/Apps";
import CollectionsIcon from "@mui/icons-material/Collections";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ContactPageOutlinedIcon from "@mui/icons-material/ContactPageOutlined";

import { Global } from "@emotion/react";
import { Link, useNavigate } from "react-router-dom";
import { motion, useScroll } from "motion/react";

const services = [
	{ title: "Projects", description: "High-quality academic projects tailored for students.", image: academicImage },
	{ title: "Dissertations", description: "Professional assistance for writing and reviewing dissertations.", image: dissertationImage },
	{ title: "Publications", description: "Publish your work in recognized journals with our support.", image: publicationImage },
	{ title: "Assignments", description: "Help with assignments to achieve academic success.", image: assignmentImage },
	{ title: "Internships", description: "Get hands-on experience with internships tailored to your field.", image: internshipImage },
	{ title: "Training", description: "Enhance your skills with our comprehensive training programs.", image: trainingImage },
];

// Custom AppBar that changes background on scroll
function ElevateAppBar(props) {
	const navigate = useNavigate();
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
	const { scrollYProgress } = useScroll();
	const [anchorEl, setAnchorEl] = useState(null);
	const trigger = useScrollTrigger({
		disableHysteresis: true,
		threshold: isMobile ? 0 : 150, // how far to scroll before it changes
	});
	const handleMenuOpen = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleMenuClose = (path) => {
		navigate(path);
		setAnchorEl(null);
	};

	const home = () => {
		window.location.href = "/";
	};

	return (
		<>
			<AppBar
				position='fixed'
				elevation={trigger ? 2 : 0}
				sx={{
					transition: "background-color 0.3s ease",
					backgroundColor: trigger ? "rgba(0, 0, 0, 1)" : "rgba(0, 0, 0, 0)",
					// color: "#fff",
					// border: "1px solidrgb(78, 78, 78)",
				}}
			>
				<DiscountBanner />
				<Toolbar>
					{isMobile ? (
						<Box className='header'>
							<Tooltip title='Tech Logics' placement='right'>
								<Box onClick={home} component='img' sx={{ height: 40 }} src={logo} />
							</Tooltip>
							<IconButton edge='start' color='inherit' aria-label='menu' onClick={handleMenuOpen}>
								<MenuIcon />
							</IconButton>
							<Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose} sx={{ width: "300px" }}>
								<MenuItem color='primary' onClick={() => handleMenuClose("/projects")}>
									<AppsIcon color='primary' sx={{ mr: 1 }} />
									<Typography color='primary'>Projects</Typography>
								</MenuItem>
								<MenuItem onClick={() => handleMenuClose("/about-us")}>
									<InfoOutlinedIcon color='success' sx={{ mr: 1 }} /> <Typography color='success'>About Us</Typography>
								</MenuItem>
								<MenuItem onClick={() => handleMenuClose("/contact-us")}>
									<ContactPageOutlinedIcon color='warning' sx={{ mr: 1 }} /> <Typography color='warning'>Contact Us</Typography>
								</MenuItem>
							</Menu>
						</Box>
					) : (
						<>
							<Tooltip title='Tech Logics' placement='right'>
								<Link to={"/"}>
									<Box
										component='img'
										sx={{
											height: 40,
										}}
										src={logo}
									/>
								</Link>
							</Tooltip>
							<Typography variant='h6' sx={{ flexGrow: 1 }}></Typography>
							<Button className='btn-hover' onClick={() => navigate("/projects")} color='white'>
								Projects
							</Button>
							<Button className='btn-hover' onClick={() => navigate("/about-us")} color='white'>
								About us
							</Button>
							<Button className='btn-hover' onClick={() => navigate("/contact-us")} color='white'>
								Contact us
							</Button>
						</>
					)}
				</Toolbar>
				<motion.div
					id='scroll-indicator'
					style={{
						scaleX: scrollYProgress,
						position: "absolute",
						bottom: 0,
						left: 0,
						right: 0,
						height: 4,
						originX: 0,
						backgroundColor: "#ff0090",
						transformOrigin: "left",
						zIndex: 9999,
					}}
				/>
			</AppBar>
		</>
	);
}

const Posters = () => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
	const settings = {
		// dots: true,
		infinite: true,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 3000,
		// arrows: false,
		pauseOnHover: false,
	};

	return (
		<Box my={0.25}>
			<ElevateAppBar />
			<Box>
				<Slider {...settings}>
					{services.map((service, index) => (
						<Box key={index} className='carousel-card'>
							<Card
								sx={{
									position: "relative",
								}}
							>
								<CardMedia component='img' image={service.image} alt={service.title} height={isMobile ? "270" : "580"} />
								<Box
									sx={{
										position: "absolute",
										top: 0,
										left: 0,
										width: "100%",
										height: "100%",
										bgcolor: "rgba(0, 0, 0, 0.4)",
										display: "flex",
										flexDirection: "column",
										justifyContent: "center",
										alignItems: "center",
										color: "#fff",
										textAlign: "center",
										// px: 2,
									}}
								>
									<Typography variant={isMobile ? "h6" : "h3"} fontWeight='bold'>
										{service.title}
									</Typography>
									<Typography variant={isMobile ? "body2" : "h6"} mt={1}>
										{service.description}
									</Typography>
								</Box>
							</Card>
						</Box>
					))}
				</Slider>
			</Box>
		</Box>
	);
};

export default Posters;
